import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Icon.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [_jsx(views.VerticalLine, _objectSpread({}, tokens)), _jsx(views.HorizontalLine, _objectSpread({}, tokens))]
  }));
});
export var Icon = withDesignTokens(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
export default Icon;